"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWordPressPlansFromPayload = exports.getValueFromWordPressPlans = exports.getCurrencyFromWordPressPlans = exports.getGA4ECommerceItemsFromWordPressPlans = exports.getGA3ECommerceItemsFromWordPressPlans = exports.getGA4ECommerceDataFromWordPressPlans = exports.ECommerceCurrency = void 0;
var ECommerceCurrency;
(function (ECommerceCurrency) {
    ECommerceCurrency["USD"] = "USD";
    ECommerceCurrency["CAD"] = "CAD";
})(ECommerceCurrency = exports.ECommerceCurrency || (exports.ECommerceCurrency = {}));
const getGA4ECommerceDataFromWordPressPlans = (plans) => {
    return {
        currency: (0, exports.getCurrencyFromWordPressPlans)(plans),
        items: (0, exports.getGA4ECommerceItemsFromWordPressPlans)(plans),
        value: (0, exports.getValueFromWordPressPlans)(plans),
    };
};
exports.getGA4ECommerceDataFromWordPressPlans = getGA4ECommerceDataFromWordPressPlans;
/**
 * (deprecated) This is a GA3/UA specific method for converting WordPress plans to GA4 EcommerceItems
 *
 * @param plans WordPressPlan[] | []
 * @returns EcommerceItem[]
 */
function getGA3ECommerceItemsFromWordPressPlans(plans = []) {
    let items = [];
    if (plans == null || plans.length == 0) {
        plans = window.lsc_plans;
    }
    if (plans) {
        items = plans.map((plan, index) => {
            const item = {
                brand: plan.long_name,
                currency: plan.currency ? plan.currency : ECommerceCurrency.USD,
                discount: 0,
                id: plan.product_id,
                index: index,
                name: plan.short_name,
                price: plan.price,
            };
            return item;
        });
    }
    return items;
}
exports.getGA3ECommerceItemsFromWordPressPlans = getGA3ECommerceItemsFromWordPressPlans;
/**
 * This is a GA4 specific method for converting WordPress plans to GA4 ECommerceEventItems
 *
 * @param plans WordPressPlan[] | []
 * @returns IECommerceEventItem[]
 */
const getGA4ECommerceItemsFromWordPressPlans = (plans = []) => {
    plans = plans == null || plans.length == 0 ? window.lsc_plans : plans;
    return plans && (plans === null || plans === void 0 ? void 0 : plans.length)
        ? plans.map((plan, index) => {
            const item = {
                discount: 0,
                index,
                item_brand: plan === null || plan === void 0 ? void 0 : plan.long_name,
                item_category: plan === null || plan === void 0 ? void 0 : plan.planType,
                item_id: plan.product_id,
                item_name: plan === null || plan === void 0 ? void 0 : plan.long_name,
                item_variant: plan === null || plan === void 0 ? void 0 : plan.short_name,
                price: Number(plan.price),
            };
            return item;
        })
        : [];
};
exports.getGA4ECommerceItemsFromWordPressPlans = getGA4ECommerceItemsFromWordPressPlans;
/**
 * This is a WordPressPlan specific method that takes currency from any existing plan items
 * or defaults to USD
 *
 * @param plans WordPressPlan[] | []
 * @returns Currency
 */
const getCurrencyFromWordPressPlans = (plans) => {
    var _a, _b;
    return plans && plans.length > 0 && ((_a = plans[0]) === null || _a === void 0 ? void 0 : _a.currency)
        ? (_b = plans[0]) === null || _b === void 0 ? void 0 : _b.currency
        : 'USD';
};
exports.getCurrencyFromWordPressPlans = getCurrencyFromWordPressPlans;
/**
 * This is a WordPressPlan specific method that takes the sum of all plan prices
 *
 * @param plans WordPressPlan[] | []
 * @returns number
 */
const getValueFromWordPressPlans = (plans) => {
    return plans && plans.length > 0
        ? plans.reduce((total, plan) => {
            const price = Number(plan === null || plan === void 0 ? void 0 : plan.price);
            return total + (price ? price : 0);
        }, 0)
        : 0;
};
exports.getValueFromWordPressPlans = getValueFromWordPressPlans;
/**
 * A method that can take a single or array of WordPressPlan or WordPressPlanPayload and turn it into a WordPressPlan[]
 * This is useful for ensuring that the payload is always an array of WordPressPlan objects
 *
 * @param payload WordPressPlan | WordPressPlanPayload | WordPressPlan[] | WordPressPlanPayload[]
 * @returns WordPressPlan[]
 */
const getWordPressPlansFromPayload = (payload) => {
    let plans = Array.isArray(payload)
        ? payload
        : [payload];
    plans = plans.map((plan) => {
        const out = Object.prototype.hasOwnProperty.call(plan, 'long_name')
            ? plan
            : Object.assign(plan, {
                long_name: plan.productName,
                price: plan.productPrice,
                product_id: plan.productName,
                short_name: plan.shortcode,
            });
        return out;
    });
    return plans;
};
exports.getWordPressPlansFromPayload = getWordPressPlansFromPayload;
//# sourceMappingURL=wordpress-util.js.map